let isRefreshing = false
let refreshPromise: Promise<void> | null = null

export async function refreshAuthToken() {
  const refreshToken = useCookie<string | null>('iqa-refresh-token')
  if (!refreshToken.value) {
    throw new Error('No refresh token');
  }

  // Evitar múltiples refresh simultáneos
  if (isRefreshing && refreshPromise) {
    return refreshPromise;
  }

  isRefreshing = true

  refreshPromise = (async () => {
    try {
      const config = useRuntimeConfig()

      let baseURL = config.public.useProxy === 'true'
        ? config.public.proxyTargetApi
        : config.public.apiBaseURL;
        
      const authToken = useCookie<string | null>('iqa-token')
      const selectedTenant = JSON.parse(localStorage.getItem("iqa-auth") || '""').selectedTenant;
      const tenant = selectedTenant?.code ?? null;
      const { $i18n } = useNuxtApp();
      const res: any = await $fetch(`${baseURL}/login/refresh`, {
        method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'X-Tenant': tenant,
          'tenantCode' : `${tenant}`,
          'Accept-Language': $i18n?.locale.value || 'en',
        },
        body: {
          refreshToken: refreshToken.value,
          tenantCode: `${tenant}`
        }
      })
      const authStore = useAuthStore()

      if (!res.data.accessToken || !res.data.refreshToken || !res.data.expiration|| !res.data.accessTokenExpiresIn)
      {
        throw new Error('Unhandled Error')
      }

      authStore.setToken(
        {
          token : res.data.accessToken, 
          refreshToken : res.data.refreshToken, 
          expiration : res.data.expiration, 
          accessTokenExpiresIn  : res.data.accessTokenExpiresIn
        }
      );

    } catch (error) {
      const authStore = useAuthStore()
      authStore.logout()
      throw error
    } finally {
      isRefreshing = false
      refreshPromise = null
    }
  })()

  return refreshPromise
}